/*@flow*/
import gql from 'graphql-tag';
import type { DocumentNode } from 'graphql';

export const GET_MY_AREAS = (gql(`
  query GetMyAreas {
    me {
      id
      districts {
        id
        name
        geojson
        color
        dashboardId
      }
    }
  }
`): DocumentNode);

export const DELETE_AREA = (gql(`
  mutation districtDestroy($input: districtDestroyInput!) {
    districtDestroy(input: $input) {
      errors
      success
    }
  }
`): DocumentNode);

export const GET_QUOTAS = (gql(`
  query GetMyQuotas {
    me {
      id
      quotas {
        name
        size
        capacity
      }
    }
  }
`): DocumentNode);

export const UPDATE_DISTRICT = (gql(`
  mutation updateDistrict(
    $id: ID!
    $name: String
    $color: String!
    $geojson: String
  ) {
    districtUpdate(
      input: { id: $id, name: $name, color: $color, geojson: $geojson }
    ) {
      success
      record {
        id
        name
        geojson
        color
        dashboardId
      }
      errors
    }
  }
`): DocumentNode);

export const CREATE_DISTRICT = (gql(`
  mutation createDistrict($name: String!, $color: String!, $geojson: String!) {
    districtCreate(input: { name: $name, color: $color, geojson: $geojson }) {
      success
      record {
        id
        name
        geojson
        color
        dashboardId
      }
      errors
    }
  }
`): DocumentNode);

export const SHARE_MAP_OF_DISTRICT = (gql(`
  mutation convertDistrict($id: ID!, $showImagesInListView: Boolean!, $sortByLastUpdated: Boolean!) {
    districtConvert(input: { id: $id, showImagesInListView: $showImagesInListView, sortByLastUpdated: $sortByLastUpdated }) {
      success
      record {
        id
        name
        geojson
        color
        dashboardId
      }
      errors
    }
  }
`): DocumentNode);

export const refetchQueries = [{ query: GET_MY_AREAS }, { query: GET_QUOTAS }];
